/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdColProps, TdRowProps } from './type';

export const rowDefaultProps: TdRowProps = {
  /** 列之间的间距（默认单位px） */
  gutter: 0,
};

export const colDefaultProps: TdColProps = {
  /** 列的偏移量（默认单位px） */
  offset: 0,
  /** 列的宽度（默认单位px） */
  span: 0,
};
